import {
  func, shape, string, arrayOf, bool, number, oneOfType
} from 'prop-types';

export const propTypes = {
  listId: string.isRequired,
  onClick: func,
  onDelete: func,
  width: oneOfType([number, string]),
  height: oneOfType([number, string]),
  data: shape({
    id: string,
    name: string,
    url: string,
    public: bool,
    itemCount: number,
    images: arrayOf(shape({
      url: string
    }))
  })
};

export const defaultProps = {
  onDelete: null,
  onClick: null,
  data: null,
  width: 'auto',
  height: '100%'

};

export const themeProps = {
  showShareList: bool
};

export const defaultThemeProps = {
  showShareList: false
};
